<script setup lang="ts">
import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useAToast } from '@Atoms';
import { useChunkPreloadErrorHandling } from '@Composables';
import { APP_VERSION, SKEW_PROTECTION_ENABLED } from '@Constants';
import { useSessionStore } from '@Stores';
import { useAuthTabSync } from '@AuthModule';

const { isLogged } = storeToRefs(useSessionStore());
const { state, isOnHover } = useAToast();
const ROUTE = useRoute();
const ROUTER = useRouter();

useChunkPreloadErrorHandling();
useAuthTabSync();

watch(isLogged, () => checkUserSession());

function checkUserSession() {
  if (isLogged.value) return;
  if (ROUTE.path === '/login') return;

  const momentForLocalStorageAcrossTabsToSync = 10;
  setTimeout(() => {
    ROUTER.push('/login');
  }, momentForLocalStorageAcrossTabsToSync);
}

console.log('App version', APP_VERSION, '| skew protection', SKEW_PROTECTION_ENABLED ? 'on' : 'off');
</script>

<template>
  <RouterView />

  <AToast
    v-bind="state"
    @mouseenter="isOnHover = true"
    @mouseleave="isOnHover = false"
    @onDismiss="state.isOpen = false"
  />
</template>
